import { Component, ChangeDetectorRef, NgZone, Output, Input, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Overlay } from '@angular/cdk/overlay';

import { DistributionList } from '../users/distribution-list.model';
import { DistributionListsDialogComponent } from '../users/distribution-lists-dialog.component';
import { TokenItem } from './tokens-field.component';
import { EmailsFieldComponent } from './emails-field.component';
import { User } from '../users/user.model';

@Component({
  selector: 'app-emails-and-lists-field',
  templateUrl: './tokens-field.component.html',
  styleUrls: ['./tokens-field.component.scss']
})
export class EmailsAndListsFieldComponent extends EmailsFieldComponent {

  constructor(
    cd: ChangeDetectorRef,
    overlay: Overlay,
    private dialog: MatDialog,
    private ngZone: NgZone) { super(cd, overlay) }

  @Output() listAdded = new EventEmitter<number>();
  @Input() distributionLists: DistributionList[] = [];  

  hasInputDialog: boolean = true;

  showInputDialog() {
    let dialogRef = this.dialog.open(DistributionListsDialogComponent, {
      height: Math.min(window.innerHeight, 582)+"px",
      width: Math.min(window.innerWidth, 600)+"px",
      data: {workflowId: this.workflowId}
    });
    dialogRef.afterClosed().subscribe((list) => {
      if (list != null) {
        this.addList(list);
      }
    })
  }

  addList(list: DistributionList) {
    let item = new TokenItem();
    item.value = {
      stored: list,
      displayed: list.name
    };
    item.valid = true;
    item.icon = "menu";
    item.toolTip = list.userNames;
    this.addItem(item);
    this.listAdded.emit(list.id);
  }

  loadItems(values?: any[]): TokenItem[] {
    let items = super.loadItems(values);
    for (let item of items) {
      let stored = item.value.stored;
      if (stored != null && stored.users != null) {
        let list = new DistributionList(stored);
        let existing = this.distributionLists.find((l) => { return list.id === l.id; });
        if (existing != null) { list = existing; };
        stored.users = list.users
        item.icon = "menu";
        item.toolTip = list.userNames;
        this.listAdded.emit(stored.id);
      }
    }
    return items;
  }

  emitValue() {
    let values = this.items.map((i) => i.value)
    this.valueChanged.emit({field: this.id, value: values})
  }

  itemValuesEqual(a,b): boolean {
    a = a != null ? a.stored : null;
    b = b != null ? b.stored : null;
    if (a == null || b == null) {
      return a == b;
    } else if (a.id != null || b.id != null) { // Comparing lists
      return a.id === b.id;
    } else { // Comparing emails
      return (a).caseInsensitiveCompare(b);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/emails-and-lists-field.component.ts